import React, { useCallback } from 'react'
import { styled } from '@mui/material/styles'
import { Stack } from '@mui/material'
import { useRouteError } from 'react-router-dom'
import Button from '@/components/Button'
import Text from '@/components/Text'

const FallBackPage = styled('div')(() => ({
  display: 'grid',
  height: '100%',
  width: '100%',
  placeItems: 'center',
}))

const ErrorFallBack = () => {
  const errorContent = useRouteError()
  console.error(errorContent)

  const fallBack = useCallback(() => {
    window.open('/', '_self')
  }, [])

  return (
    <FallBackPage>
      <Stack sx={{ gap: '16px', alignItems: 'center' }}>
        <Text size="md" weight="bold">
          非常抱歉，出错了
        </Text>
        <Button onClick={fallBack}>返回首页</Button>
      </Stack>
    </FallBackPage>
  )
}

export default ErrorFallBack
